import RichText from 'Custom/RichText';
import Link from 'node_modules/next/link';
import styles from 'styles/pages/questions.module.scss';

const FAQ_EXPLORING_QUESTION_1_HOME = {
  title: "¿NEXPLANON es un anticonceptivo de acción prolongada?",
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-1-paragraph">
        Sí, NEXPLANON es un{' '}
        <Link
          data-qa-tag="faq-exploring-question-1-link"
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={'implante anticonceptivo'}
          data-design-nori_id="Accordion"
          data-design-module_name="questions to talk through with your doctor"
          data-design-module_no="06"
          data-design-element_no="01"
          href="/what-is-nexplanon/"
        >
          implante anticonceptivo
        </Link>
         {" "}pequeño (aproximadamente del tamaño de un fósforo), delgado y flexible que ofrece 5 años<sup>†</sup> de prevención continua del embarazo.
      </p>
      <p data-qa-tag="faq-exploring-question-1-caption" className="caption"><sup>†</sup>NEXPLANON se debe extraer hacia el final del quinto año.</p>
    </RichText>
  ),
};


const FAQ_EXPLORING_QUESTION_2_HOME = {
  title: '¿NEXPLANON es un dispositivo intrauterino?',
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-2-paragraph">
        No, no es un dispositivo intrauterino (DIU).
      </p>
    </RichText>
  ),
};


const FAQ_EXPLORING_QUESTION_3_HOME = {
  title: '¿Qué tamaño tiene NEXPLANON?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-3-paragraph">
       NEXPLANON mide 4 centímetros (1.6 pulgadas) de largo, tiene aproximadamente el tamaño de un fósforo.
      </p>
    </RichText>
  ),
};


const FAQ_EXPLORING_QUESTION_4_HOME = {
  title: '¿Cómo funciona NEXPLANON?',
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-4-paragraph">NEXPLANON es un implante anticonceptivo liberador de hormonas para uso en mujeres que previene el embarazo durante un período de hasta 5 años.<sup>†</sup></p>
      <p data-qa-tag="faq-exploring-question-4-second-paragraph">NEXPLANON previene el embarazo de varias maneras. La más importante consiste en interrumpir la liberación de un óvulo desde su ovario.</p>
      <p data-qa-tag="faq-exploring-question-4-third-paragraph">NEXPLANON también hace más espeso el moco cervical, y este cambio puede evitar que los espermatozoides lleguen al óvulo.</p>
      <p data-qa-tag="faq-exploring-question-4-fourth-paragraph">NEXPLANON también modifica el revestimiento de su útero.</p>
      <p data-qa-tag="faq-exploring-question-4-caption" className="caption"><sup>†</sup>NEXPLANON se debe extraer hacia el final del quinto año.</p>
    </RichText>
  ),
};


const FAQ_EXPLORING_QUESTION_5_HOME = {
  title: '¿NEXPLANON funciona tan bien como la píldora?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-5-paragraph">
        NEXPLANON tiene una eficacia mayor del 99 % (menos de 1 embarazo por cada 100 mujeres que usaron NEXPLANON durante 1 año) para prevenir el embarazo. 
      </p>
      <p data-qa-tag="faq-question-5-paragraph-second">
        NEXPLANON es uno de los{' '}<Link
          data-qa-tag="faq-exploring-question-5-link"
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={'métodos anticonceptivos más eficaces disponibles'}
          data-design-nori_id="Accordion"
          data-design-module_name="questions to talk through with your doctor"
          data-design-module_no="06"
          data-design-element_no="01"
          href="/effectiveness/"
        >métodos anticonceptivos más eficaces disponibles.</Link>
      </p>
    </RichText>
  ),
};


const FAQ_EXPLORING_QUESTION_6_HOME = {
  title: '¿Qué sucede si cambio de opinión y deseo dejar de usar NEXPLANON antes de los 5 años?',
  content: (
    <RichText>
      <p data-qa-tag="faq-exploring-question-6-paragraph">
       Un profesional de la salud capacitado puede extraer el implante en cualquier momento dentro del período de 5 años.
      </p>
      <p data-qa-tag="faq-exploring-question-6-second-paragraph">
        Usted puede quedar embarazada a partir de la primera semana después de la extracción del implante.
      </p>
      <p data-qa-tag="faq-exploring-question-6-third-paragraph">
        Si no desea quedar embarazada después la extracción del implante NEXPLANON, debe comenzar a utilizar otro método anticonceptivo (como condones) de inmediato.
      </p>
    </RichText>
  ),
};

export const FAQ_HOME_QUESTIONS = [
  FAQ_EXPLORING_QUESTION_1_HOME,
  FAQ_EXPLORING_QUESTION_2_HOME,
  FAQ_EXPLORING_QUESTION_3_HOME,
  FAQ_EXPLORING_QUESTION_4_HOME,
  FAQ_EXPLORING_QUESTION_5_HOME,
  FAQ_EXPLORING_QUESTION_6_HOME,
];

